import { Component , HostListener} from '@angular/core';
import { DataService } from '../../../core/services/data/data.service';
import { RouterLink} from '@angular/router';
import { DatePipe, NgClass, SlicePipe } from '@angular/common';
import { AudioService } from '../../../core/services/audio/audio.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import emailjs from 'emailjs-com';
import { NewsService } from '../../../core/services/news/news.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [ RouterLink , NgClass , DatePipe , ReactiveFormsModule, SlicePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {


  isArabic = false;
  time = new Date();
  socials: any;
  errorMessage = '';

  messageForm: any;

  placeholderTextName: string = ''; // Default placeholder
  placeholderTextMessage: string = ''; // Default placeholder

  latestNews: any = null;
  loadingNews: boolean = false;

  constructor(
    private DataService: DataService ,
    public audioService: AudioService , 
    private fb: FormBuilder ,
    private newsService: NewsService) {}

    ngOnInit(): void {

      this.messageForm = this.fb.group({
        name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(60)]],
        message: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(60)]]
      });
  
      this.changeLang();
  
      this.socials = this.DataService.socials;
  
      setInterval(() => {
        this.time = new Date();
      }, 1000);
  
      if (this.audioService.isFailed) {
        this.errorMessage = 'Stream failed to load. Check your connection.';
      }

      this.getLatestNews();
    }

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
      this.placeholderTextName = 'الاسم...'; // Arabic placeholder
      this.placeholderTextMessage = 'المشاركة...'; // Arabic placeholder
    }
    else {
      this.isArabic = false ;
      this.placeholderTextName = 'Name...'; // English placeholder
      this.placeholderTextMessage = 'Sharing...'; // Arabic placeholder

    }
    setTimeout(() => { this.changeLang() }, 100) ;
  }

  isScaled = false;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    // Get the vertical scroll position
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // Adjust this threshold as needed
    const threshold = 850; 

    if (scrollTop > threshold) {
      this.isScaled = true;
    } else {
      this.isScaled = false;
    }
  } 

  toggleRadio() {
    if (this.audioService.isPlaying) {
      this.audioService.pauseAudio();
    } else {
      this.audioService.playAudio();
    }
  }
  
  // Function to send the message
  sendMessage() {
    if (this.messageForm.valid) {
      const formData = this.messageForm.value;
      
      // Prepare the data to be sent
      const templateParams = {
        name: formData.name,
        message: formData.message,
      };

      emailjs.send('service_v9frgle', 'template_b5bc3ka', templateParams, 'z4CmaoaQ4JGmHaO83')
        .then((response) => {
          console.log(response.text); 
        }, (error: { text: any; }) => {
          console.error(error.text);
        });
    } else {
      alert('Please fill out the form correctly.');
    }
    this.messageForm.reset();
  }

  // On form submission
  onSubmit() {
    this.sendMessage();
  }  

  getLatestNews() {
    this.loadingNews = true;
    this.newsService.getNewsPage(1, null)
      .then((result) => {
        // Get only the first (latest) news item
        this.latestNews = result.news && result.news.length > 0 ? result.news[0] : null;
        this.loadingNews = false;
      })
      .catch((error) => {
        console.error('Error loading latest news:', error);
        this.loadingNews = false;
      });
  }

}
